import { ActionReducerMap, MetaReducer } from "@ngrx/store";
import { userReducer } from "./user/user.reducer";
import { hydrationMetaReducer } from "./hydration/hydration.reducer";
import { User } from "../models/user.model";

export interface RootState {
  user: User
}

export const reducers: ActionReducerMap<RootState> = {
  user: userReducer
}

export const metaReducers: MetaReducer[] = [
  hydrationMetaReducer
]